export const CandidaturePaymentPurpose = {
    INVESTMENT: 'INVESTMENT',
    JOB_CREATION: 'JOB_CREATION',

    values: () => {
        return ['INVESTMENT', 'JOB_CREATION'];
    }
}